import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=76c9c8c8&"
import script from "./DocumentPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports